import { Link } from 'react-router-dom';

export default function VideoCta() {
  return (
    <section className="bg-[#FAF8F5] py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h4 className="text-2xl font-bold text-gray-900 mb-3">
          <a href="/inventory" className="hover:text-teal-600 transition-colors">
            See Something You Like?
          </a>
        </h4>
        <p className="text-gray-600 text-sm mb-8 max-w-2xl mx-auto">
          Every vehicle in our videos is available for purchase. Browse our full inventory or
          contact us to schedule a private walkthrough of any vehicle. Learn more about our <Link to="/broker-services" className="text-teal-600 hover:underline">broker services</Link>, read <Link to="/reviews" className="text-teal-600 hover:underline">customer reviews</Link>, or <Link to="/sell-your-car" className="text-teal-600 hover:underline">sell your car</Link> to us.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/inventory"
            className="inline-flex items-center gap-2 px-6 py-3 bg-teal-600 hover:bg-teal-700 text-white text-sm font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-car-line"></i>
            Browse Inventory
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white border border-gray-200 hover:border-teal-300 text-gray-700 hover:text-teal-600 text-sm font-semibold rounded-lg transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line"></i>
            Contact Us
          </Link>
        </div>

        {/* Social Follow */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-4">
            Follow Our Journey
          </p>
          <div className="flex items-center justify-center gap-4">
            <a
              href="https://www.youtube.com/@rockhoundauto"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-2 px-4 py-2 bg-red-50 hover:bg-red-100 text-red-600 text-sm font-medium rounded-lg transition-colors cursor-pointer"
            >
              <i className="ri-youtube-fill text-lg"></i>
              YouTube
            </a>
            <a
              href="https://www.tiktok.com/@rockhoundauto"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-800 text-sm font-medium rounded-lg transition-colors cursor-pointer"
            >
              <i className="ri-tiktok-fill text-lg"></i>
              TikTok
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-2 px-4 py-2 bg-pink-50 hover:bg-pink-100 text-pink-600 text-sm font-medium rounded-lg transition-colors cursor-pointer"
            >
              <i className="ri-instagram-fill text-lg"></i>
              Instagram
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
